import { TextNotesStatus } from "../../../../enums/textNotesStatus";

export const allTextNoteOptions = [
  { label: "Success", value: TextNotesStatus.COMPLETED },
  { label: "In Progress", value: TextNotesStatus.IN_PROGRESS },
  { label: "Error", value: TextNotesStatus.FAILED },
  { label: "NA", value: TextNotesStatus.NOT_APPLICABLE },
  { label: "Not Started", value: TextNotesStatus.NOT_INITIATED },
];
